/**
 * Copyright 2025 GDG on Campus Farmingdale State College
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const about = {
  paragraphs: [
    'GDG on Campus Farmingdale State College - Farmingdale, United States is an independent group where students can gain practical experience in building applications and services, develop their software engineering skills, and explore new areas of technology. This helps them become better prepared for careers in the technology industry and contribute to the development of innovative solutions that can positively impact society.',
    'Google Developer Groups (GDG) are community groups for developers interested in learning and practicing development skills. These groups provide a space for developers to learn how to build real-world solutions using various technologies and platforms, offering opportunities for members to connect, learn, and grow together.',
    'The purpose of GDG on Campus is to empower students to learn, grow, and connect with other developers through hands-on workshops, mentorship, and collaboration. We offer a platform for students to explore new technologies, work on real-world projects, and build their professional networks.',
    'GDG on Campus Farmingdale State College is an independent group; our activities and the opinions expressed here should in no way be linked to Google, the corporation.',
  ],
  cards: [
    {
      title: 'Practical Experience',
      color: 'blue',
      description:
        'Gain hands-on experience building applications and services while developing your software engineering skills and exploring new areas of technology.',
    },
    {
      title: 'Learn & Grow',
      color: 'red',
      description:
        'Connect with other developers through hands-on workshops, mentorship, and collaboration opportunities that help you grow your professional network.',
    },
    {
      title: 'Career Ready',
      color: 'green',
      description:
        'Become better prepared for careers in the technology industry and contribute to innovative solutions that can positively impact society.',
    },
  ],
} as const;
